import MoreVertIcon from "@mui/icons-material/MoreVert";
import StarIcon from "@mui/icons-material/Star";
import { Box, Typography } from "@mui/material";

import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoMenuItem } from "@/shared/components/RobotoMenuItem";
import { LayoutRecord } from "@/shared/domain/layouts";

import styles from "./LayoutMenuItem.module.css";

interface LayoutMenuItemProps {
  layout: LayoutRecord;
  onSelect: (layout: LayoutRecord) => void;
  onOpenContextMenu: (
    event: React.MouseEvent<HTMLElement>,
    layout: LayoutRecord,
  ) => void;
  isActive?: boolean;
  isDefault?: boolean;
}

export function LayoutMenuItem({
  layout,
  onSelect,
  onOpenContextMenu,
  isActive = false,
  isDefault = false,
}: LayoutMenuItemProps) {
  return (
    <RobotoMenuItem
      eventName={"SelectLayoutClicked"}
      eventProperties={{
        layoutId: layout.layout_id,
        layoutName: layout.name,
      }}
      disableRipple
      onClick={() => onSelect(layout)}
      className={styles.layoutItem}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2" fontWeight={isActive ? 700 : 400}>
          {layout.name}
        </Typography>
        {isDefault && (
          <StarIcon fontSize="small" sx={{ color: "text.primary", ml: 1 }} />
        )}
      </Box>
      <RobotoIconButton
        eventName={"LayoutContextMenuOpened"}
        eventProperties={{
          layoutId: layout.layout_id,
          layoutName: layout.name,
        }}
        size="small"
        onClick={(e) => onOpenContextMenu(e, layout)}
      >
        <MoreVertIcon className={styles.rightIcon} />
      </RobotoIconButton>
    </RobotoMenuItem>
  );
}
